import React, { memo } from 'react';
import "./RawHTML.css";

const RawHTML = ({ children }) => {
  return(
    <div
      id='RawHTML'
      className='pureHTML'
      dangerouslySetInnerHTML={{ __html: children.replace(/\n/g, '<br />')}} 
    />
  );
}

export default memo(RawHTML);